"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserDependentWidget = void 0;
var react_1 = __importDefault(require("react"));
var auth_1 = require("react-firebase-hooks/auth");
var __1 = require("../..");
/**
 * A React component that conditionally renders its children based on the user's authentication status.
 *
 * @param {Object} props - The component properties.
 * @param {React.ReactElement} props.children - The React elements to render when the user is authenticated.
 * @returns {React.ReactElement} Returns a Loading component if the user data is not yet available, otherwise returns the children.
 *
 * @example
 * // Example usage within another component
 * import UserDependentWidget from './path/to/UserDependentWidget';
 *
 * function ParentComponent() {
 *   return (
 *     <UserDependentWidget>
 *       <div>User is authenticated! Display this content.</div>
 *     </UserDependentWidget>
 *   );
 * }
 */
var UserDependentWidget = function (_a) {
    var children = _a.children;
    var logic = (0, __1.useEloise)().logic;
    var user = (0, auth_1.useAuthState)(logic.fb.auth)[0];
    return user ? children : react_1.default.createElement(__1.Loading, null);
};
exports.UserDependentWidget = UserDependentWidget;
